
import React from 'react';
import ReactDomServer from 'react-dom/server'
import { CurrentProfile, QuerysResponse } from '../utils/types/Contract.types';
import { Pipes } from '../utils/types/UiCloudMaterial.service.types';
import { getComputeByIndex, getHardwareToLockImage, getSizeValueByIndex, redirToCheckout } from './UiCloudMaterial.service';
import { Image, PlanBillingType } from '@/components/Cloud/Cloud.model';
import { UHCImageList } from '@/components/Cloud/Molecules/Image/ImageList/ImageList';
import { UHCColapseConfig, ColapseConfigProps } from '@/components/Cloud/Molecules/Image/ColapseConfig/ColapseConfig';
import { UHCSidebarSubTitle } from '@/components/Dumb/Atoms/Sidebar/SubTitle/SubTitle';
import { UHCImageName } from '@/components/Cloud/Atoms/Image/ImageName/ImageName';
import { TitlePage, HardwareSlidersContent } from '@/components/Dumb/Templates/Contract/Contract.style';
import { UHCSidebarServerContractProps } from '@/components/Cloud/Molecules/Server/Contract/Sidebar/Sidebar.interface';
import { UHCSidebarServerContract } from '@/components/Cloud/Molecules/Server/Contract/Sidebar/Sidebar';
import UHCTemplateAdvancedSettings from '@/components/Cloud/Organisms/AdvancedSettings/AdvancedSettings';


export const getImageFullName = (image: Image) => {
    const application = image?.application ? ` ${image.application?.name} ${image.application?.version}` : ''
    const imageName = `${image?.operationalSystem?.name} ${image?.operationalSystem?.arch} bits`

    return `${imageName}${application}`
}

export function getElementsBoxes(
    querysResponse: QuerysResponse,
    hardwareSelectedIndex: CurrentProfile,
    isColapse: [boolean, React.Dispatch<React.SetStateAction<boolean>>],
    pipesConverted: Pipes,
    onclickSetImageSelected: Function,
    onclickLineImageOnLock: Function,
    imageSelectedIndex: [number, React.Dispatch<React.SetStateAction<number>>]
) {
    const images = querysResponse.images;
    const currentImage = images[imageSelectedIndex[0]]
    const imageCheckedName = getImageFullName(currentImage)

    const hardware = getHardwareToLockImage(querysResponse.serverCatalog, hardwareSelectedIndex)
    const colapseConfig = getColapseConfig(isColapse, pipesConverted, hardwareSelectedIndex, imageCheckedName)

    const wrapChangeHardwareWithAnalytics = (image: Image) => {
        const clickedImg = getImageFullName(image)
        // if (clickedImg !== imageCheckedName) uolAnalytics('[LP2] - configurar seu cloud', clickedImg, 'trocar de template') //TODO: Avaliar o uso do UOLAnalytics

        onclickLineImageOnLock(image)
    }

    const wrapChangeImageWithAnalytics = (images: Image[], index: number) => {
        const clickedImg = getImageFullName(images[index])
        // if (clickedImg !== imageCheckedName) uolAnalytics('[LP2] - configurar seu cloud', clickedImg, 'trocar de template') //TODO: Avaliar o uso do UOLAnalytics

        onclickSetImageSelected(images, index)
    }

    const hardwareElement = (
        <HardwareSlidersContent className="container">
            <TitlePage>Configurações Avançadas</TitlePage>
            <HardwareSlidersContent>
                <UHCTemplateAdvancedSettings
                    hardwareSelectedIndex={hardwareSelectedIndex}
                    serverCatalog={querysResponse.serverCatalog}
                    currentImage={currentImage}
                    color='blue'
                />
            </HardwareSlidersContent>
        </HardwareSlidersContent>
    )

    return [
        {
            title: 'Selecione o Template para a sua configuração:',
            element: <UHCImageList
                clickChangeHardware={wrapChangeHardwareWithAnalytics}
                setImageChecked={wrapChangeImageWithAnalytics}
                hardware={hardware}
                layout={'card'}
                images={images}
                imageChecked={currentImage}
            />
        },
        {
            element: <UHCColapseConfig {...colapseConfig} />
        },
        {
            element: hardwareElement,
            collapseHide: colapseConfig.isShown
        }
    ]
}

export function getElementSidebar(
    querysResponse: QuerysResponse,
    pipesConverted: Pipes,
    currentIndexProfile: CurrentProfile,
    currentIndexImage: [number, React.Dispatch<React.SetStateAction<number>>],
    imageChecked: Image | undefined) {

    const memoryTextSidebar = `${pipesConverted.computes[currentIndexProfile.compute[0]].value} | ${pipesConverted.computes[currentIndexProfile.compute[0]].vcpu}vCPU`
    const bandwidthTextSidebar = `${pipesConverted.bandwidths[currentIndexProfile.bandwidth[0]].value}`
    const diskTextSidebar = `${pipesConverted.disks[currentIndexProfile.disk[0]].value}`
    const imageNameTextSidebar = (imageChecked) ? ReactDomServer.renderToStaticMarkup(<UHCImageName image={imageChecked} showBits={false} />) : ''

    const computeSelected = getComputeByIndex(querysResponse.serverCatalog.computes, currentIndexProfile.compute[0])
    const bandwidthValue = getSizeValueByIndex(querysResponse.serverCatalog.bandwidths.sizes, currentIndexProfile.bandwidth[0])
    const diskValue = getSizeValueByIndex(querysResponse.serverCatalog.disks.sizes, currentIndexProfile.disk[0])

    const handleContractClick = () => {
        if (imageChecked) {
            const imageName = getImageFullName(imageChecked)
            // uolAnalytics('[LP2] - configurar seu cloud', imageName, 'botão de contratar') //TODO: Avaliar o uso do UOLAnalytics
        }

        redirToCheckout(querysResponse, pipesConverted, currentIndexProfile, currentIndexImage)
    }

    const sidebarServerContractProps: UHCSidebarServerContractProps = {
        linesSidebarTop: [
            {
                title: 'Memória RAM e processamento',
                lineContent: <UHCSidebarSubTitle text={memoryTextSidebar} />
            },
            {
                title: 'Banda',
                lineContent: <UHCSidebarSubTitle text={bandwidthTextSidebar} />
            }, {
                title: 'Disco',
                lineContent: <UHCSidebarSubTitle text={diskTextSidebar} />
            },
            {
                title: 'Template',
                lineContent: <UHCSidebarSubTitle text={imageNameTextSidebar} />
            },
        ],
        profileSelected: {
            billingType: PlanBillingType.MENSAL,
            hardware: {
                bandwidth: {
                    price: querysResponse.serverCatalog.bandwidths.price,
                    size: bandwidthValue,
                    sizeIncluded: computeSelected.bandwidthAvailable.min
                },
                disk: {
                    price: querysResponse.serverCatalog.disks.price,
                    size: diskValue,
                    sizeIncluded: computeSelected.diskAvailable.min
                },
                memory: {
                    prices: computeSelected.prices,
                    vcpu: computeSelected.hardware.vcpu
                }
            },
            image: querysResponse.images[currentIndexImage[0]],
        },
        onClick: handleContractClick
    }

    return <UHCSidebarServerContract {...sidebarServerContractProps} />
}

export function getColapseConfig(
    isColapse: [boolean, React.Dispatch<React.SetStateAction<boolean>>],
    pipesConverted: Pipes,
    currentIndexProfile: CurrentProfile,
    imageCheckedName?: string
): ColapseConfigProps {
    const [isHide, setIsHide] = isColapse;

    const handleClick = () => {
        const action = isHide ? 'click abrindo' : 'click fechando'
        // uolAnalytics('[LP2] - configurar seu cloud', imageCheckedName || '', action) //TODO: Avaliar o uso do UOLAnalytics
        return setIsHide(!isHide);
    }

    return {
        memory: `${pipesConverted.computes[currentIndexProfile.compute[0]].value} | ${pipesConverted.computes[currentIndexProfile.compute[0]].vcpu}vCPU`,
        internet: `${pipesConverted.bandwidths[currentIndexProfile.bandwidth[0]].value}`,
        size: `${pipesConverted.disks[currentIndexProfile.disk[0]].value}`,
        function: handleClick,
        isShown: isHide
    }
}

